var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3525 25.0757L39.0332 27.8457L35.0122 31.8667L37.6929 34.6367L35.0122 37.3174L32.2422 34.6367L28.2212 38.6577L25.4512 35.9771L22.7705 38.6577L20.0005 35.9771L26.7915 29.186L10.4394 12.834L3.64842 19.625L0.96776 16.855L3.64842 14.1743L0.96776 11.4043L4.98876 7.3833L2.30809 4.61328L4.98876 1.93262L7.75878 4.61328L11.7798 0.592285L14.5498 3.27295L17.2305 0.592285L20.0005 3.27295L13.2095 10.064L29.5615 26.416L36.3525 19.625L39.0332 22.395L36.3525 25.0757Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeso);
export default __webpack_public_path__ + "static/media/peso.54f96159d17221b9e544c3a816a74870.svg";
export { ForwardRef as ReactComponent };